import type { IVendor } from "../../../../types/models/vendor.modals.types";
import { useGetHttp } from "../../http.hook";

interface IResponse {
  vendor: IVendor;
}


export function useGetVendorByIdAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/vendors/:vendorId",
  });
}
